import React from 'react';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import PosEventsPage from 'modules/restaurant/posEvents/PosEventsPage';

export default function DashRestaurantPosEvents() {
    return (
        <DashContainer title='Eventos'>
            <PosEventsPage />
        </DashContainer>
    );
}
